var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,style:(_vm.style)},[_c('i',{staticClass:"operate el-icon-close",staticStyle:{"z-index":"1000"},attrs:{"title":"关闭"},on:{"mousemove":function($event){$event.stopPropagation();},"click":function($event){return _vm.$emit('close')}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }